/* eslint-disable */

/** unique or primary key constraints on table "argo.location_class" */
export enum ArgoLocationClassConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  LocationClassNameUnique = 'location_class_name_unique',
  /** unique or primary key constraint on columns "location_class_id" */
  LocationClassPkey = 'location_class_pkey'
}

/** select columns of table "argo.location_class" */
export enum ArgoLocationClassSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.location_class" */
export enum ArgoLocationClassUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProfileFileId = 'profile_file_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

